import React from "react";
import { useNavigate } from "react-router-dom";
import "./AppDevelopment.css";

import heroImage from "../assets/appdev-hero.jpeg";
//import offerImage from "../assets/appdev1.png";
import whyChooseImage from "../assets/appdev2.png"; // placeholder image
import offerImage1 from "../assets/appdev-1.png";

const AppDevelopment = () => {
  const navigate = useNavigate();

  return (
    <section className="app-development-page service-page">
      {/* ================= HERO SECTION (UNCHANGED) ================= */}
      <div className="appdev-hero">
        <div className="appdev-hero-inner">
          <div className="appdev-hero-content">
            <h1 className="appdev-hero-title">
              <span className="highlight-text">App Development</span> That Drives
              Performance & Growth
            </h1>

            <p className="appdev-hero-description">
              We design and develop secure, scalable, and high performance mobile
              and web applications using modern technologies. Our solutions are
              built to deliver seamless user experiences, robust functionality,
              and long term business value across platforms.
            </p>

            <button
              className="appdev-hero-btn"
              onClick={() => navigate("/contact")}
            >
              Get In Touch
            </button>
          </div>

          <div className="appdev-hero-image">
            <img src={heroImage} alt="App Development Hero" />
          </div>
        </div>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="service-container">
        {/* ================= BELOW HERO (NO CARD) ================= */}
        <div className="appdev-below-hero">
          <p>
            We build high quality mobile and web applications for startups and
            businesses that want real results.
          </p>
          <p>
            From idea to launch, we help you create apps that are fast, easy to
            use, and built to scale.
          </p>
          <p>
            If you are looking for a reliable app development company that
            understands both technology and business, you are in the right place
          </p>
        </div>

        {/* ================= WE OFFER (NO CARD) ================= */}
        <div className="appdev-offer">
          <div className="appdev-offer-grid">
            <div className="appdev-offer-text">
              <h2 className="appdev-offer-title">We Offer</h2>

              <p className="appdev-offer-subtitle">
                We provide end to end app development services tailored to your
                business goals
              </p>

              <ul className="appdev-offer-list">
                <li>Mobile app development for Android and iOS</li>
                <li>Custom web application development</li>
                <li>Backend development and APIs</li>
                <li>Dashboards and admin panels</li>
                <li>App upgrades, performance improvements, and scaling</li>
              </ul>

              <p className="appdev-offer-note">
                Every application we build is custom designed and developed to
                fit your exact needs
              </p>
            </div>

            <div className="appdev-offer-media">
              <img src={offerImage1} alt="We Offer App Development" />
            </div>
          </div>
        </div>

        {/* ================= PROCESS (NO CARD) ================= */}
        <div className="appdev-process">
          <h2 className="appdev-process-title">Our App Development Process</h2>

          <div className="appdev-process-steps">
            <div className="appdev-step-row">
              <div className="appdev-step-number">1</div>
              <div className="appdev-step-content">
                <h3 className="appdev-step-title">
                  We Understand Your Idea First
                </h3>
                <p className="appdev-step-text">
                  Before writing a single line of code, we understand your
                  business, users, and objectives.
                </p>
              </div>
            </div>

            <div className="appdev-step-row">
              <div className="appdev-step-number">2</div>
              <div className="appdev-step-content">
                <h3 className="appdev-step-title">
                  We Design Simple and Intuitive Interfaces
                </h3>
                <p className="appdev-step-text">
                  Clean layouts, clear navigation, and smooth user experience
                  across all devices.
                </p>
              </div>
            </div>

            <div className="appdev-step-row">
              <div className="appdev-step-number">3</div>
              <div className="appdev-step-content">
                <h3 className="appdev-step-title">
                  We Develop Secure and Scalable Apps
                </h3>
                <p className="appdev-step-text">
                  Secure, reliable, and scalable applications built with modern
                  technologies.
                </p>
              </div>
            </div>

            <div className="appdev-step-row">
              <div className="appdev-step-number">4</div>
              <div className="appdev-step-content">
                <h3 className="appdev-step-title">We Support You After Launch</h3>
                <p className="appdev-step-text">
                  Ongoing support, updates, and improvements after launch.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= WHY CHOOSE US (CARD ONLY) ================= */}
        <div className="appdev-choose-card">
          <div className="appdev-choose-grid">
            <div className="appdev-choose-media">
              <img src={whyChooseImage} alt="Why Choose Us" />
            </div>

            <div className="appdev-choose-content">
              <h2 className="appdev-choose-title">Why Choose Us</h2>

              <ul className="appdev-choose-list">
                <li>Clear communication with no technical confusion</li>
                <li>On time delivery and transparent process</li>
                <li>Quality focused development</li>
                <li>Long term support and collaboration</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDevelopment;
